import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default class FlexCol extends React.PureComponent {
    render() {
        const {
            children,
            className,
            xs,
            sm,
            md,
            lg,
            xl,
            xxl,
            alignSelf,
            order,
            xsOrder,
            smOrder,
            mdOrder,
            lgOrder,
            xlOrder,
            xxlOrder,
            xsOffset,
            smOffset,
            mdOffset,
            lgOffset,
            xlOffset,
            xxlOffset,
            innerRef,
            ...rest
        } = this.props;

        const classes = cx({
            'flex-col': xs === 'auto' || (!xs && !sm && !md && !lg && !xl && !xxl),
            'flex-col-sm': sm === 'auto',
            'flex-col-md': md === 'auto',
            'flex-col-lg': lg === 'auto',
            'flex-col-xl': xl === 'auto',
            'flex-col-1': xs === 1,
            'flex-col-2': xs === 2,
            'flex-col-3': xs === 3,
            'flex-col-4': xs === 4,
            'flex-col-5': xs === 5,
            'flex-col-6': xs === 6,
            'flex-col-7': xs === 7,
            'flex-col-8': xs === 8,
            'flex-col-9': xs === 9,
            'flex-col-10': xs === 10,
            'flex-col-11': xs === 11,
            'flex-col-12': xs === 12,
            'flex-col-sm-1': sm === 1,
            'flex-col-sm-2': sm === 2,
            'flex-col-sm-3': sm === 3,
            'flex-col-sm-4': sm === 4,
            'flex-col-sm-5': sm === 5,
            'flex-col-sm-6': sm === 6,
            'flex-col-sm-7': sm === 7,
            'flex-col-sm-8': sm === 8,
            'flex-col-sm-9': sm === 9,
            'flex-col-sm-10': sm === 10,
            'flex-col-sm-11': sm === 11,
            'flex-col-sm-12': sm === 12,
            'flex-col-md-1': md === 1,
            'flex-col-md-2': md === 2,
            'flex-col-md-3': md === 3,
            'flex-col-md-4': md === 4,
            'flex-col-md-5': md === 5,
            'flex-col-md-6': md === 6,
            'flex-col-md-7': md === 7,
            'flex-col-md-8': md === 8,
            'flex-col-md-9': md === 9,
            'flex-col-md-10': md === 10,
            'flex-col-md-11': md === 11,
            'flex-col-md-12': md === 12,
            'flex-col-lg-1': lg === 1,
            'flex-col-lg-2': lg === 2,
            'flex-col-lg-3': lg === 3,
            'flex-col-lg-4': lg === 4,
            'flex-col-lg-5': lg === 5,
            'flex-col-lg-6': lg === 6,
            'flex-col-lg-7': lg === 7,
            'flex-col-lg-8': lg === 8,
            'flex-col-lg-9': lg === 9,
            'flex-col-lg-10': lg === 10,
            'flex-col-lg-11': lg === 11,
            'flex-col-lg-12': lg === 12,
            'flex-col-xl-1': xl === 1,
            'flex-col-xl-2': xl === 2,
            'flex-col-xl-3': xl === 3,
            'flex-col-xl-4': xl === 4,
            'flex-col-xl-5': xl === 5,
            'flex-col-xl-6': xl === 6,
            'flex-col-xl-7': xl === 7,
            'flex-col-xl-8': xl === 8,
            'flex-col-xl-9': xl === 9,
            'flex-col-xl-10': xl === 10,
            'flex-col-xl-11': xl === 11,
            'flex-col-xl-12': xl === 12,
            'flex-col-xxl-1': xxl === 1,
            'flex-col-xxl-2': xxl === 2,
            'flex-col-xxl-3': xxl === 3,
            'flex-col-xxl-4': xxl === 4,
            'flex-col-xxl-5': xxl === 5,
            'flex-col-xxl-6': xxl === 6,
            'flex-col-xxl-7': xxl === 7,
            'flex-col-xxl-8': xxl === 8,
            'flex-col-xxl-9': xxl === 9,
            'flex-col-xxl-10': xxl === 10,
            'flex-col-xxl-11': xxl === 11,
            'flex-col-xxl-12': xxl === 12,
            'align-self-start': alignSelf === 'start',
            'align-self-center': alignSelf === 'center',
            'align-self-end': alignSelf === 'end',
            'align-self-baseline': alignSelf === 'baseline',
            'align-self-stretch': alignSelf === 'stretch',
            'order-first': order === 'first' || xsOrder === 'first',
            'order-last': order === 'last' || xsOrder === 'last',
            'order-1': order === 1 || xsOrder === 1,
            'order-2': order === 2 || xsOrder === 2,
            'order-3': order === 3 || xsOrder === 3,
            'order-4': order === 4 || xsOrder === 4,
            'order-5': order === 5 || xsOrder === 5,
            'order-6': order === 6 || xsOrder === 6,
            'order-7': order === 7 || xsOrder === 7,
            'order-8': order === 8 || xsOrder === 8,
            'order-9': order === 9 || xsOrder === 9,
            'order-10': order === 10 || xsOrder === 10,
            'order-11': order === 11 || xsOrder === 11,
            'order-12': order === 12 || xsOrder === 12,
            'order-sm-first': smOrder === 'first',
            'order-sm-last': smOrder === 'last',
            'order-sm-1': smOrder === 1,
            'order-sm-2': smOrder === 2,
            'order-sm-3': smOrder === 3,
            'order-sm-4': smOrder === 4,
            'order-sm-5': smOrder === 5,
            'order-sm-6': smOrder === 6,
            'order-sm-7': smOrder === 7,
            'order-sm-8': smOrder === 8,
            'order-sm-9': smOrder === 9,
            'order-sm-10': smOrder === 10,
            'order-sm-11': smOrder === 11,
            'order-sm-12': smOrder === 12,
            'order-md-first': mdOrder === 'first',
            'order-md-last': mdOrder === 'last',
            'order-md-1': mdOrder === 1,
            'order-md-2': mdOrder === 2,
            'order-md-3': mdOrder === 3,
            'order-md-4': mdOrder === 4,
            'order-md-5': mdOrder === 5,
            'order-md-6': mdOrder === 6,
            'order-md-7': mdOrder === 7,
            'order-md-8': mdOrder === 8,
            'order-md-9': mdOrder === 9,
            'order-md-10': mdOrder === 10,
            'order-md-11': mdOrder === 11,
            'order-md-12': mdOrder === 12,
            'order-lg-first': lgOrder === 'first',
            'order-lg-last': lgOrder === 'last',
            'order-lg-1': lgOrder === 1,
            'order-lg-2': lgOrder === 2,
            'order-lg-3': lgOrder === 3,
            'order-lg-4': lgOrder === 4,
            'order-lg-5': lgOrder === 5,
            'order-lg-6': lgOrder === 6,
            'order-lg-7': lgOrder === 7,
            'order-lg-8': lgOrder === 8,
            'order-lg-9': lgOrder === 9,
            'order-lg-10': lgOrder === 10,
            'order-lg-11': lgOrder === 11,
            'order-lg-12': lgOrder === 12,
            'order-xl-first': xlOrder === 'first',
            'order-xl-last': xlOrder === 'last',
            'order-xl-1': xlOrder === 1,
            'order-xl-2': xlOrder === 2,
            'order-xl-3': xlOrder === 3,
            'order-xl-4': xlOrder === 4,
            'order-xl-5': xlOrder === 5,
            'order-xl-6': xlOrder === 6,
            'order-xl-7': xlOrder === 7,
            'order-xl-8': xlOrder === 8,
            'order-xl-9': xlOrder === 9,
            'order-xl-10': xlOrder === 10,
            'order-xl-11': xlOrder === 11,
            'order-xl-12': xlOrder === 12,
            'order-xxl-first': xxlOrder === 'first',
            'order-xxl-last': xxlOrder === 'last',
            'order-xxl-1': xxlOrder === 1,
            'order-xxl-2': xxlOrder === 2,
            'order-xxl-3': xxlOrder === 3,
            'order-xxl-4': xxlOrder === 4,
            'order-xxl-5': xxlOrder === 5,
            'order-xxl-6': xxlOrder === 6,
            'order-xxl-7': xxlOrder === 7,
            'order-xxl-8': xxlOrder === 8,
            'order-xxl-9': xxlOrder === 9,
            'order-xxl-10': xxlOrder === 10,
            'order-xxl-11': xxlOrder === 11,
            'order-xxl-12': xxlOrder === 12,
            'offset-0': xsOffset === 0,
            'offset-1': xsOffset === 1,
            'offset-2': xsOffset === 2,
            'offset-3': xsOffset === 3,
            'offset-4': xsOffset === 4,
            'offset-5': xsOffset === 5,
            'offset-6': xsOffset === 6,
            'offset-7': xsOffset === 7,
            'offset-8': xsOffset === 8,
            'offset-9': xsOffset === 9,
            'offset-10': xsOffset === 10,
            'offset-11': xsOffset === 11,
            'offset-sm-0': smOffset === 0,
            'offset-sm-1': smOffset === 1,
            'offset-sm-2': smOffset === 2,
            'offset-sm-3': smOffset === 3,
            'offset-sm-4': smOffset === 4,
            'offset-sm-5': smOffset === 5,
            'offset-sm-6': smOffset === 6,
            'offset-sm-7': smOffset === 7,
            'offset-sm-8': smOffset === 8,
            'offset-sm-9': smOffset === 9,
            'offset-sm-10': smOffset === 10,
            'offset-sm-11': smOffset === 11,
            'offset-md-0': mdOffset === 0,
            'offset-md-1': mdOffset === 1,
            'offset-md-2': mdOffset === 2,
            'offset-md-3': mdOffset === 3,
            'offset-md-4': mdOffset === 4,
            'offset-md-5': mdOffset === 5,
            'offset-md-6': mdOffset === 6,
            'offset-md-7': mdOffset === 7,
            'offset-md-8': mdOffset === 8,
            'offset-md-9': mdOffset === 9,
            'offset-md-10': mdOffset === 10,
            'offset-md-11': mdOffset === 11,
            'offset-lg-0': lgOffset === 0,
            'offset-lg-1': lgOffset === 1,
            'offset-lg-2': lgOffset === 2,
            'offset-lg-3': lgOffset === 3,
            'offset-lg-4': lgOffset === 4,
            'offset-lg-5': lgOffset === 5,
            'offset-lg-6': lgOffset === 6,
            'offset-lg-7': lgOffset === 7,
            'offset-lg-8': lgOffset === 8,
            'offset-lg-9': lgOffset === 9,
            'offset-lg-10': lgOffset === 10,
            'offset-lg-11': lgOffset === 11,
            'offset-xl-0': xlOffset === 0,
            'offset-xl-1': xlOffset === 1,
            'offset-xl-2': xlOffset === 2,
            'offset-xl-3': xlOffset === 3,
            'offset-xl-4': xlOffset === 4,
            'offset-xl-5': xlOffset === 5,
            'offset-xl-6': xlOffset === 6,
            'offset-xl-7': xlOffset === 7,
            'offset-xl-8': xlOffset === 8,
            'offset-xl-9': xlOffset === 9,
            'offset-xl-10': xlOffset === 10,
            'offset-xl-11': xlOffset === 11,
            'offset-xxl-0': xxlOffset === 0,
            'offset-xxl-1': xxlOffset === 1,
            'offset-xxl-2': xxlOffset === 2,
            'offset-xxl-3': xxlOffset === 3,
            'offset-xxl-4': xxlOffset === 4,
            'offset-xxl-5': xxlOffset === 5,
            'offset-xxl-6': xxlOffset === 6,
            'offset-xxl-7': xxlOffset === 7,
            'offset-xxl-8': xxlOffset === 8,
            'offset-xxl-9': xxlOffset === 9,
            'offset-xxl-10': xxlOffset === 10,
            'offset-xxl-11': xxlOffset === 11,
            'flex-col-sm-auto': sm === 'variable',
            'flex-col-md-auto': md === 'variable',
            'flex-col-lg-auto': lg === 'variable',
            'flex-col-xl-auto': xl === 'variable',
            'flex-col-xxl-auto': xxl === 'variable'
        });

        return (
            <div className={cx(classes, className)} data-component="FlexCol" ref={innerRef} {...rest}>
                {children}
            </div>
        );
    }
}

FlexCol.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.node]),
    className: PropTypes.string,
    innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    xs: PropTypes.oneOf(['auto', 'variable', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    sm: PropTypes.oneOf(['auto', 'variable', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    md: PropTypes.oneOf(['auto', 'variable', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    lg: PropTypes.oneOf(['auto', 'variable', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    xl: PropTypes.oneOf(['auto', 'variable', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    alignSelf: PropTypes.oneOf(['start', 'center', 'end', 'baseline', 'stretch']),
    order: PropTypes.oneOf(['first', 'last', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    xsOrder: PropTypes.oneOf(['first', 'last', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    smOrder: PropTypes.oneOf(['first', 'last', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    mdOrder: PropTypes.oneOf(['first', 'last', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    lgOrder: PropTypes.oneOf(['first', 'last', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    xlOrder: PropTypes.oneOf(['first', 'last', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    xsOffset: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
    smOffset: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
    mdOffset: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
    lgOffset: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
    xlOffset: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11])
};
